import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';

const TRANSLATION_KEY = 'TopViewInstructionHeading.string';

export function Heading(props) {
  const {t} = useTranslation();

  return <h4 className={props.className}>{t(TRANSLATION_KEY)}</h4>;
}

Heading.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
};

Heading.defaultProps = {
  className: '',
  text: '',
};
